import { render, staticRenderFns } from "./InternalChatMessage.vue?vue&type=template&id=bcfd0912"
import script from "./InternalChatMessage.vue?vue&type=script&lang=js"
export * from "./InternalChatMessage.vue?vue&type=script&lang=js"
import style0 from "./InternalChatMessage.vue?vue&type=style&index=0&id=bcfd0912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports